import * as Yup from 'yup';

export const userValidationSchema = Yup.object().shape({
  bio: Yup.string()
    .required('Required.')
    .max(200, 'Bio should be shorter than 200 characters.')
    .trim()
    .strict(true),
});
